import request from '@/network/axios'

//获取作业列表
export function getWorkList(params) {
  return request({
    method: 'GET',
    url: '/work/work/workList',
    params: params,
  })
}
//获取作业详情
export function getWorkDetails(params) {
  return request({
    method: 'GET',
    url: '/work/work/workDetails',
    params: params,
  })
}
//用户评价
export function setUserEvaluation(params) {
  return request({
    method: 'POST',
    url: '/work/work/userEvaluation',
    params: params,
  })
}
//作业上传
export function taskCommit(params) {
  return request({
    headers: {
      'Content-Type': 'multipart/form-data',
    },

    method: 'POST',
    url: '/work/work/workEdit',
    data: params,
  })
}
